import React from 'react';
import {apiRoutePrefix, RouteComponent} from '../../../RouteComponent';
import {Box, Divider} from '@material-ui/core';
import ObjectHeader from '../ObjectHeader';
import ObjectDefinition from '../ObjectDefinition';
import {jsonObject, purchaseOrderAttributes, purchaseOrdersHeader} from '../../data/purchaseOrders/purchaseOrder';
import RequestDefinition from "../RequestDefinition";

export default new RouteComponent(`${apiRoutePrefix}/purchase-orders`, () => {
    return (
        <div>
            <ObjectHeader data={ purchaseOrdersHeader }/>

            <Box mb={ 3 }>
                <Divider/>
            </Box>

            <ObjectDefinition data={ {
                title: 'The purchase order object',
                attributes: purchaseOrderAttributes,
                jsonObject: jsonObject
            } }/>

            {
                purchaseOrdersHeader.endpoints.map(data => (
                    <>
                        <Box mb={3}>
                            <Divider/>
                        </Box>
                        <RequestDefinition {...data} />
                    </>
                ))
            }
        </div>
    );
});
